import {Navigate, Outlet, useLocation} from 'react-router-dom';
import {useIsAuthenticated} from '@azure/msal-react';

const PrivateRoutes = () => {
    const isAuthenticated = useIsAuthenticated();
    const location = useLocation();

    if (!isAuthenticated) {
        const attemptedPath = `${location.pathname}${location.search}${location.hash}`;
        if (attemptedPath && attemptedPath !== '/login') {
            sessionStorage.setItem('postLoginRedirectPath', attemptedPath);
        }
    }

    return isAuthenticated
        ? <Outlet/>
        : <Navigate to="/login"/>;
};

export default PrivateRoutes;